// Mock data per Rete Italia Radio

export const mockCurrentTrack = {
  title: "Volare",
  artist: "Domenico Modugno",
  album: "Nel Blu Dipinto Di Blu",
  cover: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400&h=400&fit=crop",
  duration: "3:45"
};

export const mockSchedule = [
  {
    id: 1,
    time: "06:00 - 09:00",
    program: "Buongiorno Italia-Australia",
    host: "Marco Rossi",
    description: "Il programma del mattino con musica, notizie e buonumore"
  },
  {
    id: 2,
    time: "09:00 - 12:00",
    program: "Caffè Italiano",
    host: "Laura Bianchi",
    description: "Musica italiana classica e contemporanea"
  },
  {
    id: 3,
    time: "12:00 - 14:00",
    program: "Pranzo con Noi",
    host: "Giuseppe Verdi",
    description: "Compagnia durante la pausa pranzo"
  },
  {
    id: 4,
    time: "14:00 - 17:00",
    program: "Pomeriggio Down Under",
    host: "Anna Marino",
    description: "Collegamenti con l'Australia e musica internazionale"
  },
  {
    id: 5,
    time: "17:00 - 20:00",
    host: "DJ Dante",
    program: "Drive Time",
    description: "Le migliori hit per il rientro a casa"
  },
  {
    id: 6,
    time: "20:00 - 24:00",
    program: "Notte Italiana",
    host: "Sofia Romano",
    description: "Musica soft e romantica per la sera"
  }
];

export const mockPodcasts = [
  {
    id: "1",
    title: "Interviews from Il Globo & La Fiamma",
    description: "Interviste esclusive con personalità della comunità italiana in Australia",
    episodes: 50,
    image: "https://resources.italianmedia.com.au/images/podcasts/interviste.jpg",
    duration: "30 min",
    link: "https://ilglobo.com/podcasts/interviews/"
  },
  {
    id: "2",
    title: "Tony Tardio Show",
    description: "Il meglio dell'intrattenimento italiano con Tony Tardio",
    episodes: 120,
    image: "https://resources.italianmedia.com.au/images/podcasts/viva.jpg",
    duration: "45 min",
    link: "https://ilglobo.com/podcasts/tony-tardio/"
  },
  {
    id: "3",
    title: "Viva L'Allegria con James Liotta",
    description: "Musica, cultura e buonumore con James Liotta",
    episodes: 80,
    image: "https://resources.italianmedia.com.au/images/podcasts/allegria.jpg",
    duration: "40 min",
    link: "https://ilglobo.com/podcasts/viva-lallegria/"
  },
  {
    id: "4",
    title: "Ottanta voglia di musica",
    description: "Un viaggio nostalgico attraverso i successi degli anni '80",
    episodes: 45,
    image: "https://resources.italianmedia.com.au/images/podcasts/OTTANTA2.jpg",
    duration: "40 min",
    link: "https://ilglobo.com/podcasts/ottanta-voglia-di-musica/"
  },
  {
    id: "5",
    title: "La Testa nel Pallone",
    description: "Tutto sul calcio italiano e internazionale",
    episodes: 65,
    image: "https://resources.italianmedia.com.au/images/podcasts/latesta.jpg",
    duration: "50 min",
    link: "https://ilglobo.com/podcasts/la-testa-nel-pallone-podcast/"
  },
  {
    id: "6",
    title: "Insieme a Poni Poselli",
    description: "Conversazioni con Poni Poselli su temi attuali",
    episodes: 90,
    image: "https://resources.italianmedia.com.au/images/podcasts/poni.jpg",
    duration: "35 min",
    link: "https://ilglobo.com/podcasts/insieme-poni-poselli/"
  }
];

export const mockSocialLinks = {
  facebook: "https://www.facebook.com/reteitalia",
  instagram: "https://www.instagram.com/reteitaliaaustralia/"
};